import { useMemo, useState } from 'react';
import { relatedTerms } from '@/mocks/filmData';

const groups = ['全部', '入口', '字幕', '版本', '配音'];

export default function RelatedTerms() {
  const [group, setGroup] = useState('全部');
  const [query, setQuery] = useState('');

  const filtered = useMemo(() => {
    const q = query.trim();
    return relatedTerms.filter((term) => {
      const matchGroup = group === '全部' || term.group === group;
      const matchQuery = q === '' || term.text.includes(q);
      return matchGroup && matchQuery;
    });
  }, [group, query]);

  return (
    <section id="terms" className="scroll-mt-20 bg-background-100">
      <div className="px-5 md:px-10 py-14 md:py-20">
        <div className="flex items-center gap-3 mb-3">
          <span className="w-10 h-10 rounded-md bg-primary-100 text-primary-700 flex items-center justify-center">
            <i className="ri-search-line text-lg" aria-hidden="true"></i>
          </span>
          <span className="text-xs font-medium tracking-widest text-primary-700 uppercase">Search</span>
        </div>
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">相关搜索方向</h2>
        <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-3xl leading-relaxed">
          下面整理了与本站主题直接相关的检索写法。你可以按分类筛选，或在框内输入关键词，快速定位自己需要的方向。
        </p>

        <div className="mt-6 flex flex-col md:flex-row md:items-center gap-4">
          <div className="flex flex-wrap items-center gap-1 p-1 rounded-full bg-background-50 border border-background-200">
            {groups.map((g) => (
              <button
                key={g}
                type="button"
                onClick={() => setGroup(g)}
                className={`px-4 py-1.5 rounded-full text-sm whitespace-nowrap transition-colors cursor-pointer ${
                  group === g ? 'bg-secondary-500 text-background-50' : 'text-foreground-700 hover:text-secondary-700'
                }`}
              >
                {g}
              </button>
            ))}
          </div>

          <div className="relative w-full md:w-72">
            <i
              className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"
              aria-hidden="true"
            ></i>
            <input
              type="text"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="输入关键词，如 字幕 / 国语"
              aria-label="筛选相关搜索方向"
              className="w-full pl-9 pr-3 py-2 rounded-full bg-background-50 border border-background-200 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100"
            />
          </div>
        </div>

        <div className="mt-6 flex flex-wrap gap-2">
          {filtered.map((term) => (
            <span
              key={term.text}
              className="px-3.5 py-2 rounded-full bg-background-50 border border-background-200 text-sm text-foreground-800"
            >
              {term.text}
            </span>
          ))}
          {filtered.length === 0 && (
            <p className="text-sm text-foreground-500 py-2">没有匹配的检索方向，换个关键词试试。</p>
          )}
        </div>

        <p className="mt-6 text-xs text-foreground-500 leading-relaxed max-w-3xl">
          说明：以上为与本页主题相关的常见检索写法整理，用于帮助理解不同语言版本之间的差别，不指向具体观看来源。
        </p>
      </div>
    </section>
  );
}